export { RangeDatepicker } from './src/range-datepicker.js';
